import { render, staticRenderFns } from "./colorsBlock.vue?vue&type=template&id=6ba7b3ca&"
import script from "./colorsBlock.vue?vue&type=script&lang=js&"
export * from "./colorsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports